import { AxiosResponse } from 'axios'
import magentoAxios from '../../api/global/magentoAxios'


import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'

interface ResetPasswordPayload {
  email: string
  newPassword: string
  resetPasswordToken: string
  recaptchaToken?: string
}

interface ResetPasswordResponse {
  data: {
    resetPassword: boolean | null
  }
  errors?: [{ message: string }]
}

export const resetPasswordMutation = gql`
  mutation($email: String!, $resetPasswordToken: String!, $newPassword: String!) {
    resetPassword(
      email: $email,
      resetPasswordToken: $resetPasswordToken,
      newPassword: $newPassword
    )
  }
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const resetPassword = async (payload: ResetPasswordPayload): Promise<void> => {
  const { data }: AxiosResponse<ResetPasswordResponse> = await magentoAxios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    recaptchaToken: payload.recaptchaToken,
    headers: {
      'Content-Type': 'application/json',
      Store: getStoreName(),
    },
    data: {
      query: resetPasswordMutation,
      variables: {
        email: payload.email,
        resetPasswordToken: payload.resetPasswordToken,
        newPassword: payload.newPassword,
      },
    },
  } as any)

  if (data.errors) {
    throw data.errors[0].message
  }
}
